// make a selection read-only
const makeReadOnly = (selector) => {
  const id = selector.substring(1) // Remove the # prefix
  const element = document.getElementById(id)

  // Hide elements
  const hideElements = (selectors) => {
    selectors.forEach(sel => {
      element.querySelectorAll(sel).forEach(el => {
        el.classList.add('d-none')
      })
    })
  }

  const disableElements = (selectors) => {
    selectors.forEach(sel => {
      element.querySelectorAll(sel).forEach(el => {
        el.setAttribute('disabled', 'disabled')
      })
    })
  }

  hideElements([
    '.btn-add',
    '.btn-remove',
    '.attach_user_document',
    '.button',
    '.submit'
  ])

  disableElements([
    // Exclude the slideout offcanvas toggle so the section menu can still
    // be opened on small screens when the document is read-only.
    'button:not(.sa-slideout-btn)',
    'input',
    'optgroup',
    'option',
    'select',
    'textarea',
    '.ready-for-sign-off a',
    '.reject a'
  ])

  // Disable tom-select instances
  element.querySelectorAll('select').forEach(selectElement => {
    if (selectElement.tomselect) {
      selectElement.tomselect.disable()
    }
  })
}

export default makeReadOnly
